import { TableName } from '../../tables'
import { Action, TableActions } from './types'

export const readPermissions = (): TableActions[] => 
    Object.values(TableName).map(tableName => ({
        tableName,
        actions: [
            Action.GET_ALL,
            Action.GET,
            Action.GET_BY_PARAMS,
            Action.GET_BY_IDS
        ]
    } as TableActions))
    .concat([
        {
            tableName: TableName.SALE_ORDERS,
            indexName: '*',
            actions: [Action.GET_ALL]
        },
        {
            tableName: TableName.HOARD_ORDERS,
            indexName: '*',
            actions: [Action.GET_ALL]
        },
        {
            tableName: TableName.DELIVERY_ORDERS,
            indexName: '*',
            actions: [Action.GET_ALL]
        }
    ] as TableActions[])
